<template>
	<!-- Layout inner -->
  <div class="layout-inner">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content can_full_screen">

        <div class="hd_bar">
          <div class="hd_ic ic-course"></div>
          <div class="hd_txt">
            <v-clamp class="title_txt" autoresize :max-lines="2" id="courseTitle">{{ course.title }}</v-clamp>

            <b-popover ref="courseTitlePopupContainer" target="courseTitle" triggers="click" placement="top" class="title_popup" container="courseTitleContainer">
              <div class="title_container">
                {{ course.title }}
              </div>
              <div class="ic_container">
                <span class="ic ic-close" v-on:click="hideCourseTitlePopup"></span>
              </div>
            </b-popover>
            <div id="courseTitleContainer" class="title_container_popup"></div>
          </div>
        </div>

        <div class="btn_bar">
          <button class="btn_toc" @click="showToc">
            <span class="ic22-btnToC"></span>
          </button>

          <div class="btn_container">
            <b-button v-if="entity" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: entity.objectType, entityUuid: entity.uuid } }" class="btn button-primary next" aria-label="previous">
              <span class="btn_txt float-left">
                <span> prev </span>
              </span>
            </b-button>
            <template v-if="toBeLocked" >
              <b-button v-if="nextEntity" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: lockedTopic.objectType, entityUuid: lockedTopic.uuid , locked:toBeLocked} }" class="btn button-primary next" aria-label="next">
                <span class="btn_txt">
                  <span> next </span>
                </span>
              </b-button>
            </template>
            <template v-else-if="(( (nextEntity.ancestor===entity.ancestor ) ||  !(course.includeCDesc || course.includeCAI )))" >
              <b-button v-if="nextEntity" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: nextEntity.objectType, entityUuid: nextEntity.uuid } }" class="btn button-primary next" aria-label="next">
                <span class="btn_txt">
                  <span> next </span>
                </span>
              </b-button>
              </template>
              <template v-else>
                <b-button v-if="nextEntity" :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: nextTOCType, entityUuid: nextTOCUuid } }" class="btn button-primary next" aria-label="next">
                  <span class="btn_txt">
                    <span> next </span>
                  </span>
                </b-button>
              </template>
            <full-screen-method></full-screen-method>
          </div>
        </div>

        <div class="row sub_hd_bar resource">
          <div class="col-12">
            <div class="sub_hd_ic">
              <span v-if="entity.fileType === 'assessment'" class="ic ic-assessment"></span>
              <span v-if="entity.fileType === 'video'" class="ic ic-video"></span>
              <span v-if="entity.fileType === 'pdf'" class="ic ic-file-pdf"></span>
              <span v-if="entity.fileType === 'doc' || entity.fileType === 'docx'" class="ic ic-file-word"></span>
              <span v-if="entity.fileType === 'xlsx'" class="ic ic-file-excel"></span>
              <span v-if="entity.fileType === 'html'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'externalurl'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'other'" class="ic ic-pageURL"></span>
              <span v-if="entity.fileType === 'jpg' || entity.fileType === 'jpeg' || entity.fileType === 'png' || entity.fileType === 'gif'" class="ic ic-image"></span>
            </div>
            <div class="sub_hd_txt">
              <v-clamp class="title_txt" autoresize :max-lines="2" id="entityTitle">{{ entity.title }}</v-clamp>

              <b-popover ref="entityTitlePopupContainer" target="entityTitle" triggers="click" placement="top" class="title_popup" container="entityTitleContainer">
                <div class="title_container">
                  {{ entity.title }}
                </div>
                <div class="ic_container">
                  <span class="ic ic-close" v-on:click="hideEntityTitlePopup"></span>
                </div>
              </b-popover>
              <div id="entityTitleContainer" class="title_container_popup"></div>

            </div>
          </div>
        </div>
        <!-- Page content -->
        <div class="container-fluid flex-grow-1 container-p-y" v-if="allDataLoaded">
          <div>
            <!--<div v-html="entity.description"></div>-->
            <template v-if="isEntityActivityLoaded">
              <div v-if="entity.type !== 'ASSESSMENT'">
                Great! You completed {{entity.title}}. Keep going!
                <!--
                <div>Time spent on this resource:</div>
                <div><strong>{{msToTime(entityActivity.resourceTimeTaken)}}</strong></div>
                -->
              </div>
              <div v-if="entity.type === 'ASSESSMENT'">
                <p>{{kCMessage}}</p>
              </div>
            </template>
            <div v-if="entity.objectType === 'LearningContent'" class="mb-4">
              <div v-if="entity.type === 'ASSESSMENT'">
                <template v-if="isAssessmentDetailLoaded">
                  <assessment-detail :uuid="course.uuid" :entityUuid ="entity.uuid" :entityType="entity.objectType"></assessment-detail>
                </template>
              </div>
              <div v-else>
                <b-link variant="primary" :to="{name: 'resourceLearn', params: { uuid: course.uuid, entityUuid: entity.uuid, entityType: entity.objectType, isTransitionPage:true } }">Click to look at the resource again</b-link>
              </div>
            </div>
            <div v-if="isNextEntityDetailLoaded  && ( (nextEntity.ancestor===entity.ancestor ) ||  !(course.includeCDesc || course.includeCAI ))" class="mb-5">
              <div class="mb-4" style="border-top: 1px solid;"></div>
              <div class="">
              <template v-if="!toBeLocked">
                <div v-if="nextEntity.title !== 'COURSE_FINISHED' && nextEntity.title !== 'KC_SUBMITTED'">
                  <div>
                    <div>Go to the next lesson by clicking</div>
                  </div>
                  <div class="btn_container mt-4" style="text-align: right;">
                    <b-link :to="{ name: 'entityDetail', params: { uuid: course.uuid, entityType: nextEntity.objectType, entityUuid: nextEntity.uuid, subTopicUuid: nextEntity.ancestor } }" class="btn continue-learning">
                      continue learning
                    </b-link>
                  </div>
                </div>
              </template>
              <template v-if="toBeLocked">
                <div v-if="nextEntity.title !== 'COURSE_FINISHED' && nextEntity.title !== 'KC_SUBMITTED'">
                  <div>
                    <div>
                      <span v-if="lockedTopic.unlockReliantOnType==4">
                        Next Micro Competency "{{lockedTopic.title}}" is locked because you have not completed the previous Competency! <br/><br/>
                        Please complete all the Micro Competency in "{{lockedTopic.unlockReliantOnTitle[0]}}" to access this.
                      </span>
                      <span v-if="lockedTopic.unlockReliantOnType==5">
                        Next Micro Competency "{{lockedTopic.title}}" is locked because you have not completed the previous Micro Competency! <br/> <br/>
                        Please complete  "{{lockedTopic.unlockReliantOnTitle[0]}}" Micro Competency to access this.
                      </span>
                      <span v-if="lockedTopic.unlockReliantOnType==3">
                        Next Micro Competency is locked because you have not completed the Diagnostic Test! <br/><br/>
                        Please complete Diagnostic Test "{{lockedTopic.unlockReliantOnTitle[0]}}" to access this.
                      </span>
                      <span  v-if="lockedTopic.unlockReliantOnType==2">
                        Next Micro Competency will open on "{{lockedTopic.unlockReliantOnTitle[0]}}".
                      </span>                    
                      <span  v-if="lockedTopic.unlockReliantOnType==1">
                        Next Micro Competency will open when "{{lockedTopic.unlockReliantOnTitle[0]}}".
                      </span>                    

                    </div>
                  </div>
                </div>
              </template>

                <div v-if="nextEntity.title === 'COURSE_FINISHED'">
                  <div class="col-12 navigate-to-dashboardPage">
                    <div class="success-msg ace_sec_txt">
                      You’ve finished the course <i>{{'"'+ course.title + '"'}}</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
                       <template v-if="nextCTitle && nextMCTitle" >
                       Let’s move to the next Topic : {{nextCTitle}} starting with sub topic {{nextMCTitle}}
                       </template>
                       <template v-else>
                       <template v-if="nextCTitle" >
                       Let’s move to the next Topic : {{nextCTitle}}
                       </template>
                       <template v-if="nextMCTitle" >
                       Let’s move to the next Topic : {{nextMCTitle}}
                       </template>
                       </template>
           </div>
            <div v-if="!isNextEntityDetailLoaded">
              <template v-if="serverError">
                <div class="mt-5 text-center">Server Error. Please try after some time.</div>
              </template>
              <template v-else>
                <spinner size="large"></spinner>
              </template>
            </div>
          </div>
        </div>
        <!-- Footer Navbar
        <template v-if="entityUuid">
          <course-footer-navbar :uuid="uuid" :entityUuid="entityUuid" :isTransitionPage="true"></course-footer-navbar>
        </template>
        <template v-else>
          <course-footer-navbar :uuid="uuid"></course-footer-navbar>
        </template>
         / Footer Navbar -->
      </div>
    </div>

    <div class="modal_popup_container">
      <b-modal class="toc_modal" ref="tocModal" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">
            Table of Contents
          </div>
          <div class="btn_container">
            <button class="btn_close" aria-label="close" @click="hideToc">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div>
          <table-of-contents :uuid="uuid"></table-of-contents>
        </div>
      </b-modal>
    </div>

      <b-modal id="logicModalContainer" class="full_screen_modal modal__v22_2" ref="logicModal"  size="" hide-footer no-close-on-backdrop no-close-on-esc>

        <div slot="modal-header" class="header-section">
          <div class="hd_txt">
            {{competencyLogic.messageTitle}}
          </div>
          <div class="close_btn_container">
            <button class="btn_close" aria-label="close" @click="closeComptencyLogicModal">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <!--
        <div class="row entity_head">
          <div class="col-12">
            <div class="hd_txt">
              {{competencyLogic.messageTitle}}
            </div>
          </div>
        </div>
        -->

        <div class="rich-html-container-parent">
          <div v-html="competencyLogic.message">
          </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import CourseFooterNavbar from '../../misc/components/./CourseFooterNavbar'
import fullScreenMethod from '../../misc/components/fullScreenMethod'
import AssessmentDetail from '../../assessment/components/AssessmentDetail'
import VClamp from 'vue-clamp'
import TOC from './TOC'
import TableOfContents from './TableOfContents'

export default {
  name: 'entity-result',
  props: ['uuid', 'entityType', 'entityUuid'],
  components: {
    Navbar,
    CourseFooterNavbar,
    fullScreenMethod,
    AssessmentDetail,
    VClamp,
    TOC,
    TableOfContents
  },
  data: () => {
    return {
      isAssessmentDetailLoaded: false,
      isNextEntityDetailLoaded: false,
      isEntityActivityLoaded: false,
      nextEntity: null,
      entityActivity: null,
      serverError: false,
      kCMessage: '',
      nextTOCUuid:'',
      nextTOCType:'',
      nextCTitle:'',
      nextCOrder:'',
      nextMCTitle:'',
      toBeLocked: false,
      lockedTopic: {},
      allDataLoaded: false,
      linearTopics:[],
      competencyLogicMap : {},
      competencyLogic : {}
    }
  },

  mounted () {
    this.loadDetail()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEntityDetail',
      'loadEntityActivity',
      'loadNextEntityDetail',
      'loadCourseLinearTopics',
      'stopActivity',
      'loadTopicDetail',
      'loadCompetencyLogic',
      'loadKCMessage',
      'loadTopicDetail',
      'loadCompetencyLogic'
    ]),

    showToc () {
      this.$refs.tocModal.show()
    },

    hideToc () {
      this.$refs.tocModal.hide()
    },

    async loadDetail () {
      await this.loadCourseDetail(this.uuid)

      var nextEntityDetailInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      let resNext = await this.loadNextEntityDetail(nextEntityDetailInfo)
      if (resNext) {
        if (resNext.error) {
          this.serverError = true
        } else {
          this.nextEntity = resNext
          this.serverError = false
          this.isNextEntityDetailLoaded = true
        }
      }
      this.linearTopics = await this.loadCourseLinearTopics({uuid: this.uuid, loadDataFromServer: true})

      if(this.nextEntity.ancestor!==this.entity.ancestor ){
        for (var i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.entityUuid) {
            for (var j = i + 1; j < this.linearTopics.length; j++) {
              if(this.nextEntity.ancestor === this.linearTopics[j].uuid){
                if(this.linearTopics[j].locked){
                  this.nextTOCUuid = this.linearTopics[j].uuid
                  this.nextTOCType = this.linearTopics[j].objectType
                  this.lockedTopic = this.linearTopics[j]
                  this.toBeLocked = true
                  break              
                }
              }
              if(this.course.includeCAI || this.course.includeCDesc){
                  if (this.linearTopics[j].objectType === 'LearningTopic') {
                    if(this.entity.diagonesticTest && this.linearTopics[j].uuid !== this.nextEntity.ancestor){
                        continue
                    }
                    this.nextTOCUuid = this.linearTopics[j].uuid
                    this.nextTOCType = this.linearTopics[j].objectType
                  // Next Topic C to C - C, MC to MC - MC
                  if(this.nextEntity.ancestor === this.nextTOCUuid){
                    this.nextMCTitle = this.linearTopics[j].title
                    this.nextCTitle = ''
                    this.nextCOrder = this.linearTopics[j].orderId
                  }else{
                    this.nextCTitle = this.linearTopics[j].title
                    this.nextCOrder = this.linearTopics[j].orderId
                    if(this.linearTopics[j+1] && this.nextEntity.ancestor===this.linearTopics[j+1].uuid){
                      this.nextMCTitle = this.linearTopics[j+1].title
                    }
                  }
                  break
                }
              }
            }
          }
        }
      }
      var entityDetailInfo = {
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      let resEntity = await this.loadEntityDetail(entityDetailInfo)
      if (resEntity && resEntity.type === 'ASSESSMENT') {
        this.isAssessmentDetailLoaded = true
        var stopActivity = {
          'userId': this.userObj.uuid,
          'entityUuid': this.entityUuid,
          'rating': '0'
        }
        this.stopActivity(stopActivity)
        this.loadKCMessage({entityId: this.entityUuid, courseType: this.course.courseType}).then(kCRes => {
          this.kCMessage = kCRes
        })
      }

      var entityActityInfo = {
        'courseUuid': this.uuid,
        'entityType': this.entityType,
        'entityUuid': this.entityUuid
      }
      let activityRes = await this.loadEntityActivity(entityActityInfo)
      if (activityRes) {
        this.entityActivity = activityRes
        this.isEntityActivityLoaded = true
      }

      if (resNext.type === 'SCORM') {
        return this.$router.push({ name: 'entityDetail', params: { uuid: this.course.uuid, entityType: resNext.objectType, entityUuid: resNext.uuid } })
      }
      if (this.nextTOCType!=='LearningTopic' && resNext.type !== 'ASSESSMENT' && resEntity.type !== 'ASSESSMENT' && this.nextEntity.title !== 'COURSE_FINISHED') {
        return this.$router.push({ name: 'resourceLearn', params: { uuid: this.course.uuid, entityType: resNext.objectType, entityUuid: resNext.uuid } })
      }
      this.allDataLoaded = true
      if(this.course.includePostMessage){
          this.competencyLogicMap = await this.loadCompetencyLogic({courseId:this.course.uuid, type:'POST'})
          if(this.nextEntity.ancestor!==this.entity.ancestor){
              // Moving to next C/MC
              // get the current object ancestor Message
              let currentCompetencyid = this.getParentCompetencyId(this.entity.ancestor)
              this.competencyLogic = this.competencyLogicMap[currentCompetencyid]
              //
              if(!this.competencyLogic || !this.competencyLogic.message){
                // No Post Message set for current ancestor
                // get the parent message only if next move to C
                let preCId = this.getPreviousC()

                //a
                this.competencyLogic = this.competencyLogicMap[preCId]
              }
              if(!this.competencyLogic){
                  this.competencyLogic = {}
              }
              // Open Message
              if(this.competencyLogic && this.competencyLogic.message){
                  this.openComptencyLogicModal()
              }
          }
      }

    },
    getParentCompetencyId(parentId){
      for (var i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === parentId) {
            return this.linearTopics[i].competencies[0]
            break
          }
      }
      return ''
    },
    getPreviousC(){
      let parentType = 'MC'
      let nextCompetencyId = ''
      for (var i = 0; i < this.linearTopics.length; i++) {
          if (this.linearTopics[i].uuid === this.nextEntity.ancestor) {
            let nextParent = this.linearTopics[i]
            if(nextParent.ancestor === this.course.uuid){
                // the means the nextEntity Parent is C
                parentType = 'C'
                nextCompetencyId = nextParent.uuid
            }else{
                nextCompetencyId = getParentCompetencyId(nextParent.ancestor)
            }
            break
          }
      }

      for (var j = 0; j < this.linearTopics.length; j++) {
          if (this.linearTopics[j].uuid === this.entity.ancestor) {
              let currentParent = this.linearTopics[j]
              if(currentParent.ancestor === this.course.uuid){
                  return currentParent.competencies[0]
              }else{
                  for (var k = j - 1; k >= -1; k--) {
                    let currentGrandParent = this.linearTopics[k]
                    if(currentGrandParent.ancestor === this.course.uuid){
                        if(nextCompetencyId!==currentGrandParent) {
                          return currentGrandParent.competencies[0]
                        }
                    }
                  }
              }
            break
          }
      }
    },

    openComptencyLogicModal () {
    if(this.$refs.logicModal){
        this.$refs.logicModal.show()
     }
    },
    closeComptencyLogicModal () {
      this.$refs.logicModal.hide()
    },
    msToTime (s) {
      var ms = s % 1000
      s = (s - ms) / 1000
      var secs = s % 60
      s = (s - secs) / 60
      var mins = s % 60
      if (mins < 10) {
        mins = '0' + mins
      }
      var hrs = (s - mins) / 60
      if (hrs < 10) {
        hrs = '0' + hrs
      }
      return hrs + ' hrs : ' + mins + ' mins : ' + secs + ' seconds'
    },
    hideCourseTitlePopup () {
      this.$refs.courseTitlePopupContainer.$emit('close')
    },
    hideEntityTitlePopup () {
      this.$refs.entityTitlePopupContainer.$emit('close')
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'course': state => state.dashboard.course,
      'entity': state => state.dashboard.entity    })
  },
  watch: {
    entityUuid (newId) {
      if (newId) {
        this.loadDetail()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/EntityResult.vue